module.exports = __webpack_public_path__ + "img/mostly-cloudy-snow.2447ab6.svg";